import React, { useEffect, useState } from 'react'

import { extractDateTime } from "../../utils/date"
import notFound from "../Contacts/Table/NotFoundData"
import { StorageGetItem, USER } from "../../lib/storage"
import { formatUserWithContactGroups } from "../../utils/assignees"
import HistoryTypeCell from "./HistoryTypeCell"
import { NavLink } from "react-router-dom"
import { handleTableId } from "../../helpers/helper"
import SortableTableHeader from "../../components/Table/SortableTableHeader"
import TableSkeletonRows from "../../components/Skeleton/TableSkeletonRows"
import { useMyContextLoading } from "../../components/LoadingContextProvider/LoadingContextProvider"
import { TABLE_CARD_INNER, TABLE_HEAD_ROW } from "../../components/Table/tableCardClass"


const TableList = ({ history, historyPage = false, sortField = '', sortOrder = '', onSort }) => {
  const [userRole, setUserRole] = useState("")
  const { isBarLoading } = useMyContextLoading()
  const showSkeleton = isBarLoading && !(history?.length > 0)

  useEffect(() => {
    StorageGetItem(USER).then((result) => {
      setUserRole(result?.role)
    })
  }, [])

  return (
    <div style={{ minHeight: history?.length === 0 ? 300 : undefined }}>
      <div className={`${TABLE_CARD_INNER} overflow-x-auto`}>
        <table className="text-md text-left w-full text-text-primary min-w-max border-collapse">
          <thead className="w-full">
            <tr className={TABLE_HEAD_ROW}>
              {historyPage && (
                <th className="pl-5 py-4 font-semibold text-[13px] uppercase">Contact Id</th>
              )}
              <th className="pl-5 py-4 font-semibold text-[13px] uppercase">Type</th>
              <SortableTableHeader
                label="Created"
                field="createdAt"
                currentSortField={sortField}
                currentSortOrder={sortOrder}
                onSort={onSort}
                sortable={!!onSort}
              />
              <SortableTableHeader
                label="Message"
                field="message"
                currentSortField={sortField}
                currentSortOrder={sortOrder}
                onSort={onSort}
                sortable={!!onSort}
              />
            </tr>
          </thead>
          <tbody>
            {showSkeleton ? (
              <TableSkeletonRows rows={8} colSpan={historyPage ? 4 : 3} />
            ) : history?.length === 0 ? (
              <tr>
                <td colSpan={historyPage ? 4 : 3}>
                  {notFound()}
                </td>
              </tr>
            ) : (
              history?.map((row) => (
                <tr key={row._id} className="border-b border-divider hover:bg-action-hover transition-colors">
                  {historyPage && (
                    <td className="pl-5 py-4 text-primary-main font-semibold cursor-pointer">
                      {row?.user ? (
                        <NavLink to={`/contact/${row?.user}`} className="cursor-pointer">
                          {handleTableId(row?.user)}
                        </NavLink>
                      ) : ' - '}
                    </td>
                  )}
                  <td className="pl-5 py-3">
                    {/* Left, like every other column - centring left the badge
                        floating in the middle of the column with its header
                        stranded at the far left. */}
                    <div className="flex items-center justify-start">
                      <HistoryTypeCell type={row?.type} />
                    </div>
                  </td>
                  <td className="pl-5 py-3">
                    <div className="font-bold whitespace-normal" key={row?.creator?._id}>
                      {row?.creator?.firstName ? formatUserWithContactGroups({ user: row?.creator, userRole }) : 'System'}
                    </div>
                    <div className="flex flex-col">
                      <span>{extractDateTime(row?.createdAt)}</span>
                    </div>
                  </td>
                  <td className="pl-5 py-3">
                    <div className="w-full break-words">
                      {row?.message}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TableList
